import "./Earring.css"
import Product1 from "../Components/Product1"

import Earring1 from "../images/er1.jpg"
import Earring2 from "../images/er2.jpg"
import Earring3 from "../images/er3.jpg"
import Earring4 from "../images/er4.jpg"
import Earring5 from "../images/er5.jpg"
import Earring6 from "../images/er6.jpg"
import Earring7 from "../images/er7.jpg"
import Earring8 from "../images/er8.jpg"
import Earring9 from "../images/jwelleryadd.jpg"

export default function Earring() {

  return (
    <div className="stdivinhome">
       <div className="add"><img src={Earring9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="ear1"  prdName="NECKLACE" img={Earring1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1 id="ear2" prdName="NECKLACE" img={Earring2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          

          </div>

          <div className="home__prd1">

          
          <Product1 id="ear3" prdName="BANGLES" img={Earring3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="ear4" prdName="BANGLES" img={Earring4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="ear5" prdName="EAR-RINGS " img={Earring5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="ear6" prdName="EAR-RINGS" img={Earring6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="ear7" prdName="NECKLACE" img={Earring7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="ear8" prdName="EAR-RINGS" img={Earring8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}